import React, { useState, useEffect } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'

/**
 * Modal para ingresar la descripción del cheque (número, vencimiento, etc.)
 * Props:
 * - open: boolean
 * - onClose: ()=>void
 * - descripcionDelCheque: string | null | undefined (valor inicial)
 * - onConfirm: (descripcionFinal: string) => void
 */
const DescripcionChequeModal = ({
  open,
  onClose,
  descripcionDelCheque,
  onConfirm
}) => {
  const [chequeNumber, setChequeNumber] = useState('')
  const [vencimiento, setVencimiento] = useState('')

  // Sincronizar prop con estado interno, usando '' si es null/undefined
  useEffect(() => {
    setChequeNumber(descripcionDelCheque ?? '')
  }, [descripcionDelCheque, open])

  const handleConfirm = async () => {
    // Asegurar string antes de .trim()
    const base = (chequeNumber ?? '').trim()
    let finalDesc = base
    if (vencimiento) {
      finalDesc += ` | Vencimiento: ${vencimiento}`
    }
    console.log(finalDesc)
    await onConfirm(finalDesc)
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Descripción del Cheque</DialogTitle>
      <DialogContent dividers>
        <TextField
          label="Número de Cheque"
          placeholder="Ej: 123456"
          fullWidth
          margin="normal"
          value={chequeNumber}
          onChange={e => setChequeNumber(e.target.value)}
        />
        <TextField
          label="Fecha de Vencimiento"
          type="date"
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
          value={vencimiento}
          onChange={e => setVencimiento(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={!((chequeNumber ?? '').trim())}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DescripcionChequeModal
